"use client";

import { type ReactNode, type Ref, useRef } from "react";

import { clsx } from "../../utils/clsx";
import { multipleRefs } from "../../utils/multiple-refs";
import { ScrollAreaScrollbar, type ScrollAreaScrollbarType } from "./scroll-area-scrollbar";

export interface ScrollAreaProps {
  type?: ScrollAreaScrollbarType;
  className?: string;
  viewportClassName?: string;
  contentClassName?: string;
  children?: ReactNode;
  viewportRef?: Ref<HTMLDivElement | null>;
  scrollbarClassName?: string;
  thumbClassName?: string;
}

export const ScrollArea = ({
  className,
  viewportClassName,
  contentClassName,
  type = "hover",
  children,
  viewportRef: externalViewportRef,
  scrollbarClassName,
  thumbClassName,
}: ScrollAreaProps) => {
  const scrollAreaRef = useRef<HTMLDivElement>(null);
  const viewportRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const commonScrollbarProps = {
    className: scrollbarClassName,
    thumbClassName,
    type,
    scrollAreaRef,
    viewportRef,
    contentRef,
  };

  return (
    <div className={clsx("relative overflow-hidden", className)} ref={scrollAreaRef}>
      <div className={clsx("scrollbar-hidden", viewportClassName)} ref={multipleRefs(viewportRef, externalViewportRef)}>
        <div className={clsx("h-max w-max", contentClassName)} ref={contentRef}>
          {children}
        </div>
      </div>

      <ScrollAreaScrollbar {...commonScrollbarProps} orientation="horizontal" />
      <ScrollAreaScrollbar {...commonScrollbarProps} orientation="vertical" />
    </div>
  );
};
